import '../style.css'
import * as THREE from 'three';
// import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'; // Remove OrbitControls import
import { LevelData, TileType } from './game/level-data';
import { level1 } from './game/levels/level1';
import { level2 } from './game/levels/level2';
import { level3 } from './game/levels/level3';
import { level4 } from './game/levels/level4';
import { level5 } from './game/levels/level5';
import { level6 } from './game/levels/level6';
import { level7 } from './game/levels/level7';
import { level8 } from './game/levels/level8';
import { level9 } from './game/levels/level9';
import { level10 } from './game/levels/level10';
import { level11 } from './game/levels/level11';
import { level12 } from './game/levels/level12';
import { level13 } from './game/levels/level13';
import { level14 } from './game/levels/level14';
import { level15 } from './game/levels/level15';
import { level16 } from './game/levels/level16';
import { level17 } from './game/levels/level17';
import { level18 } from './game/levels/level18';
import { level19 } from './game/levels/level19';
import { level20 } from './game/levels/level20';

// Level Progression
const levels: LevelData[] = [
    level1, level2, level3, level4, level5,
    level6, level7, level8, level9, level10,
    level11, level12, level13, level14, level15,
    level16, level17, level18, level19, level20
]; // Array of 20 levels

// --- Constants ---
const TILE_SIZE = 1;
const TILE_DEPTH = 0.1; // How thick the tiles are
const BASE_FORWARD_SPEED = 12; // Base speed - Increased!
const BOOST_MULTIPLIER = 2; // How much faster boost makes you
const SLOW_MOTION_MULTIPLIER = 0.5; // Speed factor on slow tiles
const SIDEWAYS_SPEED = 6; // Units per second for left/right movement - Slightly increased
const JUMP_FORCE = 6;
const GRAVITY = -15;
const HIGH_SCORE_COUNT = 5; // How many high scores to keep
const HIGH_SCORE_KEY = 'whispertrail_highscores'; // Local storage key
const RESTART_DELAY = 2000; // Milliseconds before restarting level

// Warp Effect Constants
const NORMAL_FOV = 75;
const BOOST_FOV = 90;
const FOV_TRANSITION_SPEED = 5.0; // Speed of FOV change
const NORMAL_STAR_SCALE_Z = 1.0;
const BOOST_STAR_SCALE_Z = 3.0; // How much to stretch stars on Z
const STAR_SCALE_TRANSITION_SPEED = 5.0; // Speed of star scale change
const SPEED_ACCELERATION_SPEED = 15.0; // How quickly speed ramps UP (higher = faster accel)
const SPEED_DECELERATION_SPEED = 2.5; // How quickly speed ramps DOWN (lower = slower decay)
const FINISH_DECELERATION_FACTOR = 0.85; // Stronger deceleration after finish

// --- State ---
let moveLeft = false;
let moveRight = false;
let jumpRequested = false; // Add jumpRequested flag here
let velocityY = 0;
let isOnGround = true;
let isBoostJumping = false; // Flag for boosted jump momentum
let isBoostEffectActive = false; // Visual effect state
let isCountingDown = false; // Flag for level start countdown
let isFinishing = false; // Flag for finish line slowdown sequence
let isMusicLoaded = false; // Flag for music loading
let isGameReadyToStart = false; // Flag for initial level setup
let hasGameStarted = false; // Flag to check if user clicked start
let currentLevelIndex = 0; // Track current level
let remainingTime: number;
let score = 0;
let lives = 3; // Add lives state
let gameOver = false;
let animationFrameId: number | null = null; // To stop the loop
let currentForwardSpeed = BASE_FORWARD_SPEED; // Current speed, can be boosted

// --- Mouse Look State ---
let isDragging = false;
let previousMousePosition = { x: 0, y: 0 };
let cameraYaw = 0;   // Rotation around Y (left/right)
let cameraPitch = 0; // Rotation around X (up/down)
const mouseSensitivity = 0.005;
const maxPitch = Math.PI / 2 - 0.1; // Limit looking straight up/down
const minPitch = -Math.PI / 2 + 0.1;

// --- UI Elements ---
const timerElement = document.getElementById('timer');
const scoreElement = document.getElementById('score');
const livesElement = document.getElementById('lives'); // Get lives element
const levelNameElement = document.getElementById('level-name-display'); // Get Level Name element
const messageElement = document.getElementById('message');
const highScoreListElement = document.getElementById('high-score-list');
const retryQuitContainer = document.getElementById('retry-quit-container'); // Get button container
const retryButton = document.getElementById('retry-button');
const quitButton = document.getElementById('quit-button');
const countdownElement = document.getElementById('countdown'); // Get countdown element
const loadingOverlayElement = document.getElementById('loading-overlay'); // Get loading overlay
const loadingMessageElement = document.getElementById('loading-message'); // Get loading message
const restartGameContainer = document.getElementById('restart-game-container'); // Get restart container
const restartGameButton = document.getElementById('restart-game-button'); // Get restart button
const jumpButtonContainer = document.getElementById('jump-button-container'); // Get jump button container
const jumpButton = document.getElementById('jump-button'); // Get jump button

if (!timerElement || !scoreElement || !livesElement || !levelNameElement || !messageElement || !highScoreListElement || !retryQuitContainer || !retryButton || !quitButton || !countdownElement || !loadingOverlayElement || !loadingMessageElement || !restartGameContainer || !restartGameButton || !jumpButtonContainer || !jumpButton) { // Check for new elements
    throw new Error('UI elements not found!');
}

// --- Setup ---
const gameContainer = document.getElementById('game-container');

if (!gameContainer) {
    throw new Error('Game container not found!');
}

// Scene
const scene = new THREE.Scene();
scene.background = new THREE.Color(0x000000); // Black background for space
scene.fog = new THREE.FogExp2(0x000000, 0.01); // Black fog, adjust density if needed

// Add Stars and Planets
const stars = createStars();
scene.add(stars);
const distantPlanets = createDistantPlanets();
scene.add(distantPlanets);

// Camera
const camera = new THREE.PerspectiveCamera(
    75, // Field of view
    window.innerWidth / window.innerHeight, // Aspect ratio
    0.1, // Near clipping plane
    1000 // Far clipping plane
);
// Add Audio Listener to the camera
const listener = new THREE.AudioListener();
camera.add(listener);

// Position camera to look down at the track - Lowered and closer
camera.position.set(0, 2.5, 3.5); // Positioned lower and closer
camera.lookAt(0, 0, -2); // Look slightly further down the track

// Renderer
const renderer = new THREE.WebGLRenderer({ antialias: true });
renderer.setSize(window.innerWidth, window.innerHeight);
renderer.shadowMap.enabled = true; // Enable shadows
gameContainer.appendChild(renderer.domElement);

// Lighting
const ambientLight = new THREE.AmbientLight(0xffffff, 0.4); // Reduce ambient light for space
scene.add(ambientLight);

const directionalLight = new THREE.DirectionalLight(0xffffff, 1.0); // Stronger directional light
directionalLight.position.set(5, 10, 7.5);
directionalLight.castShadow = true;
scene.add(directionalLight);

// Configure shadow properties for the light
directionalLight.shadow.mapSize.width = 1024;
directionalLight.shadow.mapSize.height = 1024;
directionalLight.shadow.camera.near = 0.5;
directionalLight.shadow.camera.far = 50;

// Define the frustum size for the shadow camera
const shadowCamSize = 10; // Adjust size as needed
directionalLight.shadow.camera.left = -shadowCamSize;
directionalLight.shadow.camera.right = shadowCamSize;
directionalLight.shadow.camera.top = shadowCamSize;
directionalLight.shadow.camera.bottom = -shadowCamSize;
directionalLight.shadow.camera.updateProjectionMatrix(); // Important!

// Optional: Add a helper to visualize the shadow camera frustum (useful for debugging)
// const shadowCameraHelper = new THREE.CameraHelper(directionalLight.shadow.camera);
// scene.add(shadowCameraHelper);

// --- Level Data / State ---
let currentLevel: LevelData;
let trackEndZ: number;

// --- Create Track Geometry ---
const trackGroup = new THREE.Group(); // Group to hold all track tiles
scene.add(trackGroup); // Add the group to the scene once
const tileGeometry = new THREE.BoxGeometry(TILE_SIZE, TILE_DEPTH, TILE_SIZE);

// --- Texture Creation Functions ---
// Function to create arrow texture for boost tiles
function createArrowTexture(bgColor = '#00ffff', arrowColor = '#008080', size = 64): THREE.CanvasTexture { // Use dark teal for arrow
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    canvas.width = size;
    canvas.height = size;

    if (!context) {
        throw new Error("Could not get 2D context for texture canvas");
    }

    // Background
    context.fillStyle = bgColor;
    context.fillRect(0, 0, size, size);

    // Ghibli-esque Thick Arrow Tip (Filled Triangle pointing up)
    context.fillStyle = arrowColor; // Use dark teal
    context.lineWidth = 0; // No stroke needed for fill

    const tipWidth = size * 0.6; 
    const baseMargin = size * 0.2; 
    
    const tipY = baseMargin; 
    const baseY = size - baseMargin; 
    const centerX = size / 2;

    context.beginPath();
    context.moveTo(centerX, tipY); 
    context.lineTo(centerX + tipWidth / 2, baseY); 
    context.lineTo(centerX - tipWidth / 2, baseY); 
    context.closePath(); 
    
    context.fill(); 

    const texture = new THREE.CanvasTexture(canvas);
    texture.magFilter = THREE.NearestFilter;
    texture.needsUpdate = true;
    return texture;
}
// Function to create checkered texture for finish line
function createCheckeredTexture(color1 = 'white', color2 = 'black', squares = 4): THREE.CanvasTexture {
    const canvas = document.createElement('canvas');
    const squareSize = 16; // Size of each square in the pattern
    canvas.width = squareSize * squares;
    canvas.height = squareSize * squares;
    const context = canvas.getContext('2d');

    if (!context) {
        throw new Error("Could not get 2D context for texture canvas");
    }

    for (let row = 0; row < squares; row++) {
        for (let col = 0; col < squares; col++) {
            context.fillStyle = ((row + col) % 2 === 0) ? color1 : color2;
            context.fillRect(col * squareSize, row * squareSize, squareSize, squareSize);
        }
    }

    const texture = new THREE.CanvasTexture(canvas);
    texture.wrapS = THREE.RepeatWrapping;
    texture.wrapT = THREE.RepeatWrapping;
    texture.magFilter = THREE.NearestFilter; // Keep pixels sharp
    // Adjust repeat based on tile size and pattern size
    texture.repeat.set(TILE_SIZE / canvas.width, TILE_SIZE / canvas.height); 
    return texture;
}

// Function to create particle texture
function createParticleTexture(size = 32): THREE.CanvasTexture {
    const canvas = document.createElement('canvas');
    canvas.width = size;
    canvas.height = size;
    const context = canvas.getContext('2d')!;
    const gradient = context.createRadialGradient(size / 2, size / 2, 0, size / 2, size / 2, size / 2);
    gradient.addColorStop(0, 'rgba(255, 255, 255, 1)'); // White center
    gradient.addColorStop(0.4, 'rgba(255, 255, 255, 0.8)');
    gradient.addColorStop(1, 'rgba(255, 255, 255, 0)'); // Fading out
    context.fillStyle = gradient;
    context.fillRect(0, 0, size, size);
    const texture = new THREE.CanvasTexture(canvas);
    return texture;
}

// --- Tile Materials ---
const standardMaterial = new THREE.MeshToonMaterial({ color: 0xcccccc }); // Grey tiles
// Boost Materials (Top + Sides)
const boostTopMaterial = new THREE.MeshToonMaterial({ 
    color: 0x00ffff, // Base color for tinting/fallback
    map: createArrowTexture(),
    // emissive: 0x00ffff, // Remove emissive property
    // emissiveIntensity: 0 // Remove initial intensity
    // transparent: true // Remove transparency flag
}); 
const boostSideMaterial = new THREE.MeshToonMaterial({ 
    color: 0x00ffff 
    // emissive: 0x00ffff, // Remove emissive property
    // emissiveIntensity: 0 // Remove initial intensity
});
// Slow Material
const slowMaterial = new THREE.MeshToonMaterial({ color: 0xff0000 }); // Red slow tiles
// Finish Materials (Top + Sides)
const finishTopMaterial = new THREE.MeshToonMaterial({ map: createCheckeredTexture() });
const finishSideMaterial = new THREE.MeshToonMaterial({ color: 0xaaaaaa }); // Grey sides for finish line

// --- Player Sphere (Create once) ---
const sphereRadius = TILE_SIZE * 0.4; // Slightly smaller than half tile size
const sphereGeometry = new THREE.SphereGeometry(sphereRadius, 32, 16); // Sphere with reasonable detail
const textureLoader = new THREE.TextureLoader();
const logoTexture = textureLoader.load('/assets/graphics/k.png');
logoTexture.wrapS = THREE.RepeatWrapping;
logoTexture.wrapT = THREE.RepeatWrapping;
const sphereMaterial = new THREE.MeshToonMaterial({ map: logoTexture });
const playerSphere = new THREE.Mesh(sphereGeometry, sphereMaterial);
playerSphere.castShadow = true;
playerSphere.receiveShadow = true;
scene.add(playerSphere);
let sphereBaseY: number; // Will be set in loadLevel

// --- Particle System ---
const particleTexture = createParticleTexture();
const activeParticles: { sprite: THREE.Sprite, velocity: THREE.Vector3, life: number, maxLife: number }[] = [];
const particleGroup = new THREE.Group();
scene.add(particleGroup);

function createParticle(position: THREE.Vector3, color: THREE.Color, velocity: THREE.Vector3, life: number, scale: number) {
    const particleMaterial = new THREE.SpriteMaterial({
        map: particleTexture,
        color: color,
        blending: THREE.AdditiveBlending,
        transparent: true,
        depthWrite: false
    });
    const sprite = new THREE.Sprite(particleMaterial);
    sprite.position.copy(position);
    sprite.scale.set(scale, scale, scale);
    particleGroup.add(sprite);
    activeParticles.push({ sprite, velocity, life, maxLife: life });
}

function updateParticles(delta: number) {
    for (let i = activeParticles.length - 1; i >= 0; i--) {
        const p = activeParticles[i];
        p.life -= delta;

        if (p.life <= 0) {
            particleGroup.remove(p.sprite);
            p.sprite.material.dispose(); // Clean up material
            activeParticles.splice(i, 1);
        } else {
            p.sprite.position.addScaledVector(p.velocity, delta);
            // Fade out and shrink
            const lifeRatio = p.life / p.maxLife;
            p.sprite.material.opacity = lifeRatio;
            const scale = p.sprite.scale.x * (0.8 + lifeRatio * 0.2); // Shrink towards 80% of original size
            p.sprite.scale.set(scale,scale,scale);
        }
    }
}

// --- Load Level Function ---
function loadLevel(levelIndex: number) {
    if (levelIndex >= levels.length) {
        console.error("Attempted to load level index out of bounds:", levelIndex);
        showMessage("Error: Level not found!");
        gameOver = true; // Stop the game if level doesn't exist
        return;
    }

    currentLevelIndex = levelIndex;
    currentLevel = levels[currentLevelIndex];
    trackEndZ = -(currentLevel.track.length - 1) * TILE_SIZE; // Z position of the center of the last row
    remainingTime = currentLevel.timeLimit; // Initialize timer for the level

    console.log(`Loading level ${currentLevelIndex + 1}: ${currentLevel.name}`);

    // Clear existing track tiles from the group
    while (trackGroup.children.length > 0) {
        trackGroup.remove(trackGroup.children[0]);
    }

    // Create and add new track tiles
    currentLevel.track.forEach((rowString, zIndex) => {
        const rowOffset = (rowString.length - 1) * TILE_SIZE / 2; // Center the row horizontally
        for (let xIndex = 0; xIndex < rowString.length; xIndex++) {
            const tileType = rowString[xIndex] as TileType;
            let tileMesh: THREE.Mesh | null = null;
            let materials: THREE.Material | THREE.Material[]; // Can be single or array

            switch (tileType) {
                case TileType.Standard:
                    materials = standardMaterial;
                    break;
                case TileType.Boost:
                    // Array order: +X, -X, +Y (Top), -Y, +Z, -Z
                    materials = [
                        boostSideMaterial, boostSideMaterial,
                        boostTopMaterial, boostSideMaterial, // Top face gets arrow texture
                        boostSideMaterial, boostSideMaterial
                    ];
                    break;
                case TileType.SlowMotion:
                    materials = slowMaterial;
                    break;
                case TileType.Finish:
                     materials = [
                        finishSideMaterial, finishSideMaterial,
                        finishTopMaterial, finishSideMaterial, // Top face gets checkered texture
                        finishSideMaterial, finishSideMaterial
                    ];
                    break;
                default: // Gap or unknown
                    continue; // Don't create a mesh
            }
            
            tileMesh = new THREE.Mesh(tileGeometry, materials);
            tileMesh.position.set(
                xIndex * TILE_SIZE - rowOffset,
                0, // Position tiles at y=0
                -zIndex * TILE_SIZE // Position tiles along negative Z axis
            );
            tileMesh.receiveShadow = true;
            tileMesh.castShadow = true;
            trackGroup.add(tileMesh);
        }
    });

    // Reset player position and physics
    const startRow = currentLevel.track[0];
    const startRowOffset = (startRow.length - 1) * TILE_SIZE / 2;
    const centerTileX = startRow.length % 2 === 1 ? Math.floor(startRow.length / 2) * TILE_SIZE - startRowOffset : 0;
    const initialY = TILE_DEPTH / 2 + sphereRadius + 0.1; // Place it above the track surface
    playerSphere.position.set(centerTileX, initialY, 0);
    playerSphere.rotation.set(0, 0, 0); // Reset rotation
    sphereBaseY = initialY; // Set base Y for the current level setup
    velocityY = 0;
    isOnGround = true;
    isBoostJumping = false;
    isFinishing = false; // Explicitly reset finishing flag
    jumpRequested = false; // Explicitly reset jump request flag
    currentForwardSpeed = BASE_FORWARD_SPEED;

    // Reset camera orientation
    cameraYaw = 0;
    cameraPitch = 0;

    // Reset movement flags
    moveLeft = false;
    moveRight = false;
    
    // Reset game state flags
    gameOver = false;
    isBoostEffectActive = false;
    // Ensure warp effect visuals are reset
    camera.fov = NORMAL_FOV;
    camera.updateProjectionMatrix();
    stars.scale.z = NORMAL_STAR_SCALE_Z;

    // Hide messages and buttons
    messageElement!.classList.add('hidden');
    retryQuitContainer!.classList.add('hidden');
    restartGameContainer!.classList.add('hidden');
    jumpButtonContainer!.classList.add('hidden'); // Hide jump button during load

    updateUI(); // Update UI for the new level
    updateHighScoreDisplay(); // Ensure high scores are displayed (might change if per-level scores are added)

    // Ensure animation loop is running if it was stopped
    if (animationFrameId === null) {
        console.log("Requesting animation frame for new level");
        // Request the frame, don't call animate directly which would cause initialization issues
        animationFrameId = requestAnimationFrame(animate); 
    }

    // Handle start prompt / countdown
    if (levelIndex === 0 && !hasGameStarted) { // Only show prompt if game hasn't started AT ALL
        isGameReadyToStart = true;
        console.log("Initial level loaded, checking music...");
        if (isMusicLoaded) {
            showStartPrompt();
        }
    } else {
        // For subsequent levels OR restarts, start countdown immediately
        startLevelCountdown(); 
    }
}

// Separate async logic for starting the game
async function initiateGameStart() {
    console.log("Initiating game start...");
    // Resume Audio Context if suspended
    if (listener.context.state === 'suspended') {
        try {
            await listener.context.resume(); 
            console.log("AudioContext resumed on user gesture.");
        } catch (err) {
            console.error("Error resuming AudioContext:", err);
        }
    }

    loadingOverlayElement!.classList.add('hidden'); 
    
    // Play music only if buffer is loaded and not already playing
    if (backgroundMusic.buffer && !backgroundMusic.isPlaying) { 
        try {
            await backgroundMusic.play(); 
            console.log("Background music started.");
        } catch (err) {
            console.error("Error trying to play background music:", err);
        }
    } else if (!backgroundMusic.buffer) {
         console.warn("Music buffer not loaded yet, cannot play.");
    }

    hasGameStarted = true; 
    startLevelCountdown(); 
}

function showStartPrompt() {
    console.log("Game ready, showing start prompt.");
    loadingMessageElement!.textContent = "Tap or Click to Start";
    loadingOverlayElement!.style.cursor = "pointer";

    // Non-async wrapper function for the event listener
    const handleStartInteraction = (event: Event) => { // Use generic Event type
        event.preventDefault();
        event.stopPropagation();

        console.log("Start interaction handler triggered by:", event.type);

        // Remove both listeners immediately using this handler function
        loadingOverlayElement!.removeEventListener('touchstart', handleStartInteraction);
        loadingOverlayElement!.removeEventListener('touchend', handleStartInteraction);
        loadingOverlayElement!.removeEventListener('click', handleStartInteraction);

        // Call the actual async game start logic
        initiateGameStart().catch(err => { // Handle potential errors from the async function
            console.error("Error during game initiation:", err);
        });
    };

    // Add listeners using the simple wrapper function - use touchend instead of touchstart for better mobile compatibility
    loadingOverlayElement!.addEventListener('touchend', handleStartInteraction, { passive: false });
    loadingOverlayElement!.addEventListener('click', handleStartInteraction);
}

// Function to handle the actual countdown sequence
function startLevelCountdown() {
    isCountingDown = true;
    countdownElement!.classList.remove('hidden');
    let countdownValue = 3;
    
    const updateCountdown = () => {
        if (countdownValue > 0) {
            countdownElement!.textContent = countdownValue.toString();
            countdownValue--;
            setTimeout(updateCountdown, 1000); // Update every second
        } else {
            countdownElement!.textContent = 'Go!';
            setTimeout(() => {
                countdownElement!.classList.add('hidden');
                isCountingDown = false; // Unpause game logic
                jumpButtonContainer!.classList.remove('hidden'); // Show jump button AFTER countdown
            }, 1000); // Show "Go!" for 1 second
        }
    };
    updateCountdown(); // Start the countdown process
}

// --- Load Initial Level ---
loadLevel(0); // Load the first level (index 0)

// --- Start Animation Loop (If not already started by loadLevel) ---
// This might be redundant if loadLevel always starts it, but safe to keep
if (animationFrameId === null) {
    animate();
}

// --- Background Music Setup ---
const audioLoader = new THREE.AudioLoader();
const backgroundMusic = new THREE.Audio(listener);

audioLoader.load('assets/audio/velocity_dreams.mp3', function(buffer) {
    console.log("Music loaded successfully.");
    backgroundMusic.setBuffer(buffer);
    backgroundMusic.setLoop(true);
    backgroundMusic.setVolume(0.5); // Adjust volume as needed
    
    isMusicLoaded = true; // Set flag
    // Check if game is already waiting
    if (isGameReadyToStart) {
        showStartPrompt(); 
    }

    // --- REMOVED old interaction listeners ---
    // const startMusic = () => { ... };
    // window.addEventListener('click', startMusic);
    // window.addEventListener('keydown', startMusic);

}, function(xhr) { // Progress
    console.log((xhr.loaded / xhr.total * 100) + '% music loaded');
}, function(err) { // Error
    console.error('An error happened loading the background music:', err);
    // Optionally allow game to start without music
    isMusicLoaded = true; // Set flag anyway so game doesn't block
    if (isGameReadyToStart) {
        showStartPrompt();
    }
});

// --- Space Environment ---
function createStars(): THREE.Points {
    const starVertices = [];
    const starCount = 5000;
    const spread = 200; // How far out the stars spread

    for (let i = 0; i < starCount; i++) {
        const x = (Math.random() - 0.5) * spread * 2;
        const y = (Math.random() - 0.5) * spread * 2;
        const z = (Math.random() - 0.5) * spread * 2;
        // Avoid stars too close to the center/track
        if (Math.abs(x) > 10 || Math.abs(y) > 10 || Math.abs(z) > 10) {
             starVertices.push(x, y, z);
        }
    }

    const starGeometry = new THREE.BufferGeometry();
    starGeometry.setAttribute('position', new THREE.Float32BufferAttribute(starVertices, 3));

    const starMaterial = new THREE.PointsMaterial({
        color: 0xffffff,
        size: 0.1,
        sizeAttenuation: true // Smaller stars further away
    });

    const stars = new THREE.Points(starGeometry, starMaterial);
    return stars;
}

function createDistantPlanets(): THREE.Group {
    const planetsGroup = new THREE.Group();
    const planetGeometry = new THREE.SphereGeometry(15, 32, 16); // Large radius

    // Planet 1 (e.g., reddish)
    const planetMaterial1 = new THREE.MeshToonMaterial({ color: 0xffa07a }); // Light Salmon
    const planet1 = new THREE.Mesh(planetGeometry, planetMaterial1);
    planet1.position.set(-80, 20, -150); // Position far away
    planetsGroup.add(planet1);

    // Planet 2 (e.g., blueish-green)
    const planetMaterial2 = new THREE.MeshToonMaterial({ color: 0x7fffd4 }); // Aquamarine
    const planet2 = new THREE.Mesh(planetGeometry.clone(), planetMaterial2);
    planet2.position.set(90, -10, -180);
    planetsGroup.add(planet2);

    // Simple Nebula/Cloud (using a Sprite with gradient texture)
    // This requires a texture, which we can simulate with Canvas
    const canvas = document.createElement('canvas');
    canvas.width = 256;
    canvas.height = 256;
    const context = canvas.getContext('2d');
    if (context) {
        const gradient = context.createRadialGradient(128, 128, 0, 128, 128, 128);
        gradient.addColorStop(0, 'rgba(150, 50, 200, 0.6)'); // Purple-ish center
        gradient.addColorStop(1, 'rgba(150, 50, 200, 0)'); // Fading out
        context.fillStyle = gradient;
        context.fillRect(0, 0, 256, 256);
        const nebulaTexture = new THREE.CanvasTexture(canvas);
        const nebulaMaterial = new THREE.SpriteMaterial({ map: nebulaTexture, blending: THREE.AdditiveBlending, depthWrite: false, transparent: true });
        const nebulaSprite = new THREE.Sprite(nebulaMaterial);
        nebulaSprite.scale.set(150, 150, 1); // Large scale
        nebulaSprite.position.set(0, 50, -200); // Position far away
        planetsGroup.add(nebulaSprite);
    }

    // Planets/Nebula should not cast shadows
    planetsGroup.traverse(child => {
        if (child instanceof THREE.Mesh || child instanceof THREE.Sprite) {
            child.castShadow = false;
            child.receiveShadow = false;
        }
    });

    return planetsGroup;
}

// --- High Score Logic ---
function getHighScores(): number[] {
    const storedScores = localStorage.getItem(HIGH_SCORE_KEY);
    if (storedScores) {
        try {
            const scores = JSON.parse(storedScores);
            // Basic validation
            if (Array.isArray(scores) && scores.every(s => typeof s === 'number')) {
                return scores;
            }
        } catch (e) {
            console.error("Error parsing high scores from local storage:", e);
        }
    }
    return []; // Return empty array if not found or invalid
}

function saveHighScore(newScore: number) {
    if (newScore <= 0) return; // Don't save zero or negative scores

    const highScores = getHighScores();
    highScores.push(newScore);
    highScores.sort((a, b) => b - a); // Sort descending (highest first)
    const updatedHighScores = highScores.slice(0, HIGH_SCORE_COUNT); // Keep only top N

    try {
        localStorage.setItem(HIGH_SCORE_KEY, JSON.stringify(updatedHighScores));
        updateHighScoreDisplay(); // Update the display after saving
    } catch (e) {
        console.error("Error saving high scores to local storage:", e);
    }
}

function updateHighScoreDisplay() {
    const highScores = getHighScores();
    highScoreListElement!.innerHTML = ''; // Clear previous list
    if (highScores.length === 0) {
        highScoreListElement!.innerHTML = '<li>No scores yet!</li>';
    } else {
        highScores.forEach((score) => {
            const li = document.createElement('li');
            li.textContent = score.toString();
            highScoreListElement!.appendChild(li);
        });
    }
}

// --- Helper Functions ---
function getTileAt(level: LevelData, worldX: number, worldZ: number): TileType | null {
    const zIndex = Math.round(-worldZ / TILE_SIZE);
    if (zIndex < 0 || zIndex >= level.track.length) {
        return null; // Outside track bounds (Z)
    }

    const rowString = level.track[zIndex];
    const rowWidth = rowString.length * TILE_SIZE;
    const rowMinX = - (rowWidth / 2 - TILE_SIZE / 2); // Center alignment taken into account
    // const rowMaxX =   (rowWidth / 2 - TILE_SIZE / 2);

    const xIndex = Math.round((worldX - rowMinX) / TILE_SIZE);

    if (xIndex < 0 || xIndex >= rowString.length) {
        return null; // Outside track bounds (X)
    }

    return rowString[xIndex] as TileType;
}

function getTrackBoundaries(level: LevelData, worldZ: number): { minX: number, maxX: number } | null {
    const zIndex = Math.round(-worldZ / TILE_SIZE);
    if (zIndex < 0 || zIndex >= level.track.length) {
        return null; // Not over a valid row
    }

    const rowString = level.track[zIndex];
    const rowWidth = rowString.length * TILE_SIZE;
    const halfWidth = rowWidth / 2;
    // Return the absolute outer edges
    return {
        minX: -halfWidth,
        maxX: halfWidth
    };
}

function updateUI() {
    timerElement!.textContent = `Time: ${Math.max(0, Math.ceil(remainingTime))}`;
    scoreElement!.textContent = `Score: ${score}`;
    livesElement!.textContent = `Lives: ${lives}`; // Update lives display
    levelNameElement!.textContent = currentLevel ? currentLevel.name : 'Loading...'; // Update level name
}

function showMessage(text: string) {
    messageElement!.textContent = text;
    messageElement!.classList.remove('hidden');
}

// --- Event Listeners ---
function onKeyDown(event: KeyboardEvent) {
    switch (event.key) {
        case 'ArrowLeft':
        case 'a': // Allow WASD too
            moveLeft = true;
            break;
        case 'ArrowRight':
        case 'd': // Allow WASD too
            moveRight = true;
            break;
        case ' ': // Spacebar
            if (isOnGround) {
                // Check tile below at the moment of jump
                const tileAtJumpStart = getTileAt(currentLevel, playerSphere.position.x, playerSphere.position.z);
                if (tileAtJumpStart === TileType.Boost) {
                    isBoostJumping = true;
                    console.log("Boost Jump!"); // Debug log
                }
                velocityY = JUMP_FORCE;
                isOnGround = false; // Immediately leave the ground

                // Emit Jump Particles
                const jumpColor = new THREE.Color(0xffffff); // White
                for (let i = 0; i < 8; i++) { // Reduced count
                    const velocity = new THREE.Vector3(
                        (Math.random() - 0.5) * 2, // Slightly less spread XZ
                        Math.random() * 1.5 + 0.5,  // Slightly less upward force
                        (Math.random() - 0.5) * 2
                    );
                    createParticle(playerSphere.position.clone().add(new THREE.Vector3(0, -sphereRadius * 0.5, 0)), jumpColor, velocity, 0.4, 0.15); // Reduced life and scale
                }
            }
            break;
    }
}

function onKeyUp(event: KeyboardEvent) {
    switch (event.key) {
        case 'ArrowLeft':
        case 'a':
            moveLeft = false;
            break;
        case 'ArrowRight':
        case 'd':
            moveRight = false;
            break;
    }
}

window.addEventListener('keydown', onKeyDown);
window.addEventListener('keyup', onKeyUp);

// --- Touch Controls ---
let activeDragTouchId: number | null = null;
let dragStartX: number = 0;
let currentDragX: number = 0;
const DRAG_THRESHOLD = 3; // Pixels threshold to start moving - Reduced for faster response
const TOUCH_SENSITIVITY = 2.0; // Multiplier for touch control responsiveness
const MAX_TOUCH_SPEED_MULTIPLIER = 2.5; // Max speed boost from touch (2.5x base speed)
let touchSpeedMultiplier = 1.0; // Current touch speed multiplier

function onTouchStart(event: TouchEvent) {
    // Check if the touch originated on a UI element we want to ignore for dragging
    const targetElement = event.target as HTMLElement;
    if (targetElement === loadingOverlayElement ||
        targetElement === jumpButton ||
        targetElement.closest('#retry-quit-container') || // Check parent for retry/quit
        targetElement === restartGameButton ||
        targetElement.closest('#jump-button-container') // Check parent for jump button
        ) {
        // Let the specific listeners on these elements handle the event
        // Do not call preventDefault() or initiate drag here.
        return;
    }

    // --- If not on an ignored element, proceed with drag logic ---
    event.preventDefault(); 
    
    // If no finger is currently dragging for movement, assign the first new touch
    if (activeDragTouchId === null && event.changedTouches.length > 0) {
        const touch = event.changedTouches[0]; // Track the first finger down
        activeDragTouchId = touch.identifier;
        dragStartX = touch.clientX;
        currentDragX = touch.clientX;
        console.log(`Touch Start: Tracking finger ID ${activeDragTouchId}`);
    }
}

function onTouchMove(event: TouchEvent) {
    // Check if the touch is on a UI element we should ignore
    const targetElement = event.target as HTMLElement;
    if (targetElement === loadingOverlayElement ||
        targetElement === jumpButton ||
        targetElement.closest('#retry-quit-container') ||
        targetElement === restartGameButton ||
        targetElement.closest('#jump-button-container')) {
        // Let the specific listeners on these elements handle the event
        return;
    }

    event.preventDefault();

    if (activeDragTouchId !== null) {
        for (let i = 0; i < event.changedTouches.length; i++) {
            const touch = event.changedTouches[i];
            if (touch.identifier === activeDragTouchId) {
                currentDragX = touch.clientX;
                // No need to set moveLeft/Right here, animate loop handles it
                break; // Found the tracked finger
            }
        }
    }
}

function onTouchEnd(event: TouchEvent) {
    // Check if the touch is on a UI element we should ignore
    const targetElement = event.target as HTMLElement;
    if (targetElement === loadingOverlayElement ||
        targetElement === jumpButton ||
        targetElement.closest('#retry-quit-container') ||
        targetElement === restartGameButton ||
        targetElement.closest('#jump-button-container')) {
        // Let the specific listeners on these elements handle the event
        return;
    }

    event.preventDefault();

    if (activeDragTouchId !== null) {
        for (let i = 0; i < event.changedTouches.length; i++) {
            const touch = event.changedTouches[i];
            if (touch.identifier === activeDragTouchId) {
                console.log(`Touch End: Releasing finger ID ${activeDragTouchId}`);
                activeDragTouchId = null; // Stop tracking
                moveLeft = false;         // Reset movement flags immediately
                moveRight = false;
                break; // Found the released finger
            }
        }
    }
}

// Register touch event listeners on canvas for better iOS Safari compatibility
const canvas = renderer.domElement;
canvas.addEventListener('touchstart', onTouchStart, { passive: false });
canvas.addEventListener('touchmove', onTouchMove, { passive: false });
canvas.addEventListener('touchend', onTouchEnd, { passive: false });
canvas.addEventListener('touchcancel', onTouchEnd, { passive: false }); // Use same end logic for cancel

// --- Button Event Handlers ---
const handleRetry = (event: Event) => {
    event.stopPropagation(); 
    retryQuitContainer!.classList.add('hidden');
    restartCurrentLevel();
};

const handleQuit = (event: Event) => {
    event.stopPropagation(); 
    retryQuitContainer!.classList.add('hidden');
    gameOver = true;
    showMessage('Game Over!'); 
    saveHighScore(score); 
    updateUI(); 
    // Ensure the loop is stopped (it should be already, but just in case)
    if (animationFrameId !== null) {
        cancelAnimationFrame(animationFrameId);
        animationFrameId = null;
    }
};

const handleRestartGame = (event: Event) => {
    event.stopPropagation();
    restartGame();
}

const handleJump = (event: Event) => {
    event.stopPropagation(); // Prevent the main touch listener from firing
    jumpRequested = true; // Set the jump flag only for this button
}

// Add button listeners (Remove old ones first just in case)
retryButton!.removeEventListener('touchstart', handleRetry);
retryButton!.removeEventListener('click', handleRetry);
quitButton!.removeEventListener('touchstart', handleQuit);
quitButton!.removeEventListener('click', handleQuit);
restartGameButton!.removeEventListener('touchstart', handleRestartGame);
restartGameButton!.removeEventListener('click', handleRestartGame); // Add click for restart too
jumpButton!.removeEventListener('touchstart', handleJump);
jumpButton!.removeEventListener('click', handleJump); // Add click for jump too

retryButton!.addEventListener('touchstart', handleRetry);
retryButton!.addEventListener('click', handleRetry); // Add click listener

quitButton!.addEventListener('touchstart', handleQuit);
quitButton!.addEventListener('click', handleQuit); // Add click listener

// Add Restart Game button listener
restartGameButton!.addEventListener('touchstart', handleRestartGame);
restartGameButton!.addEventListener('click', handleRestartGame); // Add click listener

// Add Jump Button Listener
jumpButton!.addEventListener('touchstart', handleJump);
jumpButton!.addEventListener('click', handleJump); // Add click listener

// Add Mouse Look Listeners
gameContainer!.addEventListener('mousedown', (event) => {
    isDragging = true;
    previousMousePosition.x = event.clientX;
    previousMousePosition.y = event.clientY;
});

window.addEventListener('mouseup', () => {
    isDragging = false;
});

window.addEventListener('mousemove', (event) => {
    if (!isDragging) return;

    const deltaX = event.clientX - previousMousePosition.x;
    const deltaY = event.clientY - previousMousePosition.y;

    cameraYaw -= deltaX * mouseSensitivity;
    cameraPitch -= deltaY * mouseSensitivity;

    // Clamp pitch
    cameraPitch = Math.max(minPitch, Math.min(maxPitch, cameraPitch));

    previousMousePosition.x = event.clientX;
    previousMousePosition.y = event.clientY;
});

// Prevent context menu on right-click drag over canvas
gameContainer!.addEventListener('contextmenu', (event) => event.preventDefault());

// Add clock for delta time calculation HERE, before animate is defined
const clock = new THREE.Clock();

// --- Animation Loop ---
function animate() {
    animationFrameId = requestAnimationFrame(animate); // Store frame ID
    const delta = clock.getDelta();
    const elapsedTime = clock.getElapsedTime(); // Get total elapsed time

    // --- Core Game Logic (Skip during countdown OR before game starts) ---
    if (!isCountingDown && hasGameStarted) { 
        if (gameOver) {
            // Handle final game over state (after message is shown)
            if (animationFrameId !== null) {
                cancelAnimationFrame(animationFrameId);
                animationFrameId = null; // Mark as cancelled
            }
            // Don't immediately return here if we need to show the restart button
            
            // Check if the restart button should be shown (i.e., true game over)
            if (lives <= 0 || currentLevelIndex >= levels.length) { 
                timerElement!.style.display = 'none';
                scoreElement!.style.display = 'none';
                livesElement!.style.display = 'none';
                levelNameElement!.style.display = 'none';
                retryQuitContainer!.classList.add('hidden'); // Ensure retry/quit are hidden
                jumpButtonContainer!.classList.add('hidden'); // Hide jump button on final game over
                restartGameContainer!.classList.remove('hidden'); // Show restart button
            }
            return; // Now return, game is stopped
        }

        // --- Update Timer (Run regardless of finishing state unless game over) ---
        remainingTime -= delta;
        if (remainingTime <= 0 && !gameOver) {
            remainingTime = 0;
            lives -= 1; // Decrement lives
            updateUI(); // Update UI immediately to show lost life

            if (lives > 0) {
                showMessage('Time Up! Lost a life.');
                retryQuitContainer!.classList.remove('hidden'); // Show buttons
                jumpButtonContainer!.classList.add('hidden'); // Hide jump button when retry/quit shown
                // Pause the game loop by cancelling the frame
                cancelAnimationFrame(animationFrameId!); 
                animationFrameId = null; 
                return; // Stop this frame
            } else {
                // Game Over - Time Up (Final life)
                gameOver = true;
                showMessage('Time Up! Game Over!');
                retryQuitContainer!.classList.add('hidden'); // Ensure buttons are hidden
                saveHighScore(score); // Save score on final game over
                updateUI(); // Final UI update

                // Show restart button immediately
                timerElement!.style.display = 'none';
                scoreElement!.style.display = 'none';
                livesElement!.style.display = 'none';
                levelNameElement!.style.display = 'none';
                jumpButtonContainer!.classList.add('hidden');
                restartGameContainer!.classList.remove('hidden');

                cancelAnimationFrame(animationFrameId!); // Cancel the loop permanently
                animationFrameId = null;
                return; // Stop the loop
            }
        }

        // --- Determine Target Speed & Apply Speed Changes ---
        const tileBelow = getTileAt(currentLevel, playerSphere.position.x, playerSphere.position.z);

        if (isFinishing) {
            // Apply deceleration
            currentForwardSpeed *= FINISH_DECELERATION_FACTOR;
            
            // Check if speed is low enough OR if sphere rolled too far past finish line
            const distancePastFinish = trackEndZ - playerSphere.position.z; // How far past the line
            const stopDistanceThreshold = TILE_SIZE * 2; // Max distance to roll after finish

            if (currentForwardSpeed < 0.1 || distancePastFinish > stopDistanceThreshold) {
                currentForwardSpeed = 0; // Ensure it stops fully
                isFinishing = false; // End the finishing sequence state
                
                // Stop animation loop immediately to prevent further updates
                if (animationFrameId !== null) {
                    cancelAnimationFrame(animationFrameId);
                    animationFrameId = null;
                }
                // Now perform the level transition / game end logic
                const nextLevelIndex = currentLevelIndex + 1;
                if (nextLevelIndex < levels.length) {
                    showMessage(`Level ${currentLevelIndex + 1} Complete!`);
                    setTimeout(() => loadLevel(nextLevelIndex), RESTART_DELAY);
                } else {
                    // Game Complete (Finished last level)
                    gameOver = true;
                    showMessage('Game Complete!');
                    saveHighScore(score);
                    updateUI(); // Update one last time before showing restart

                    // Show restart button immediately
                    timerElement!.style.display = 'none';
                    scoreElement!.style.display = 'none';
                    livesElement!.style.display = 'none';
                    levelNameElement!.style.display = 'none';
                    jumpButtonContainer!.classList.add('hidden');
                    restartGameContainer!.classList.remove('hidden');
                }
                return; // Exit animate for this frame
            }
        } else {
            // --- Regular Speed Calculation ---
            let idealSpeedForTile;
            if (isBoostJumping) {
                idealSpeedForTile = BASE_FORWARD_SPEED * BOOST_MULTIPLIER;
            } else if (isOnGround && tileBelow === TileType.Boost) {
                idealSpeedForTile = BASE_FORWARD_SPEED * BOOST_MULTIPLIER;
            } else if (isOnGround && tileBelow === TileType.SlowMotion) {
                idealSpeedForTile = BASE_FORWARD_SPEED * SLOW_MOTION_MULTIPLIER;
            } else if (isOnGround && tileBelow === TileType.Finish) {
                idealSpeedForTile = currentForwardSpeed; // Maintain speed initially when hitting finish
            } else {
                idealSpeedForTile = BASE_FORWARD_SPEED;
            }
            // Smoothly interpolate current speed towards the ideal speed
            const transitionSpeed = (idealSpeedForTile > currentForwardSpeed) ? SPEED_ACCELERATION_SPEED : SPEED_DECELERATION_SPEED;
            currentForwardSpeed = THREE.MathUtils.lerp(currentForwardSpeed, idealSpeedForTile, delta * transitionSpeed);
        }

        // --- Update Boost Visual Effect State (Based on final speed) ---
        const shouldBoostEffectBeActive = currentForwardSpeed > BASE_FORWARD_SPEED * (1 + (BOOST_MULTIPLIER - 1) * 0.3);
        isBoostEffectActive = shouldBoostEffectBeActive;

        // --- Apply Boost Visual Effects (FOV & Star Scale) ---
        const targetFov = isBoostEffectActive ? BOOST_FOV : NORMAL_FOV;
        camera.fov = THREE.MathUtils.lerp(camera.fov, targetFov, delta * FOV_TRANSITION_SPEED);
        camera.updateProjectionMatrix();
        const targetStarScaleZ = isBoostEffectActive ? BOOST_STAR_SCALE_Z : NORMAL_STAR_SCALE_Z;
        stars.scale.z = THREE.MathUtils.lerp(stars.scale.z, targetStarScaleZ, delta * STAR_SCALE_TRANSITION_SPEED);

        // --- Apply Movement (Forward, Sideways, Gravity) ---
        // Move sphere forward (even during deceleration)
        let forwardDistance = currentForwardSpeed * delta;
        if (playerSphere.position.y > sphereBaseY - 0.1 || tileBelow !== TileType.Gap) { // Prevent moving forward if just landed in gap
             // Exception: Don't move forward if landing ON a gap - prevents clipping through floor
             const isLandingOnGap = playerSphere.position.y <= sphereBaseY && (tileBelow === TileType.Gap || tileBelow === null);
             if (!isLandingOnGap) {
                 playerSphere.position.z -= forwardDistance;
             } else {
                 forwardDistance = 0; // Prevent rolling animation if stuck on gap edge
             }
        }
        
        // Add rolling animation based on forward movement
        if (forwardDistance !== 0) {
            const rollAngle = forwardDistance / sphereRadius;
            playerSphere.rotation.x -= rollAngle * 0.5;
        }

        // --- Handle Touch Drag for Sideways Movement ---
        if (activeDragTouchId !== null) {
            const deltaX = currentDragX - dragStartX;
            const absDeltaX = Math.abs(deltaX);

            if (absDeltaX > DRAG_THRESHOLD) {
                // Calculate proportional speed based on drag distance
                // Map drag distance to speed multiplier (1.0 to MAX_TOUCH_SPEED_MULTIPLIER)
                const dragDistance = Math.min(absDeltaX, 150); // Cap at 150px for max speed
                const normalizedDrag = dragDistance / 150; // 0 to 1
                touchSpeedMultiplier = 1 + (normalizedDrag * (MAX_TOUCH_SPEED_MULTIPLIER - 1)) * TOUCH_SENSITIVITY;

                if (deltaX < 0) {
                    moveLeft = true;
                    moveRight = false;
                } else {
                    moveLeft = false;
                    moveRight = true;
                }
            } else {
                // Within threshold, treat as no sideways input
                moveLeft = false;
                moveRight = false;
                touchSpeedMultiplier = 1.0;
            }
        } else {
            touchSpeedMultiplier = 1.0;
        }
        // Note: if activeDragTouchId is null, moveLeft/Right retain their last value from touchend (which is false)
        // This is correct as keyboard controls might still set them.

        // Calculate potential sideways movement (uses moveLeft/moveRight flags)
        // Apply touch speed multiplier only for touch input
        let sidewaysMovement = 0;
        const effectiveSidewaysSpeed = SIDEWAYS_SPEED * (activeDragTouchId !== null ? touchSpeedMultiplier : 1.0);
        if (moveLeft) sidewaysMovement -= effectiveSidewaysSpeed * delta;
        if (moveRight) sidewaysMovement += effectiveSidewaysSpeed * delta;
        let potentialX = playerSphere.position.x + sidewaysMovement;

        // Constrain X based on track boundaries
        const boundaries = getTrackBoundaries(currentLevel, playerSphere.position.z);
        if (boundaries) {
            potentialX = Math.max(boundaries.minX + sphereRadius, Math.min(boundaries.maxX - sphereRadius, potentialX));
        }
        playerSphere.position.x = potentialX;

        // --- Handle Jump Request (from touch or other sources) ---
        if (jumpRequested && isOnGround) {
            const tileAtJumpStart = getTileAt(currentLevel, playerSphere.position.x, playerSphere.position.z);
            if (tileAtJumpStart === TileType.Boost) {
                isBoostJumping = true;
                console.log("Touch Boost Jump!"); // Debug log
            }
            velocityY = JUMP_FORCE;
            isOnGround = false;
            jumpRequested = false; // Reset the flag

            // Emit Jump Particles (copied from onKeyDown)
            const jumpColor = new THREE.Color(0xffffff); // White
            for (let i = 0; i < 8; i++) { 
                const velocity = new THREE.Vector3(
                    (Math.random() - 0.5) * 2, 
                    Math.random() * 1.5 + 0.5,  
                    (Math.random() - 0.5) * 2
                );
                createParticle(playerSphere.position.clone().add(new THREE.Vector3(0, -sphereRadius * 0.5, 0)), jumpColor, velocity, 0.4, 0.15); 
            }
        } else {
             jumpRequested = false; // Ensure flag is reset if jump condition isn't met (e.g., already in air)
        }

        // Apply gravity and update vertical position
        velocityY += GRAVITY * delta;
        playerSphere.position.y += velocityY * delta;

        // --- Emit Boost Particles --- 
        /*
        if (isBoostEffectActive && !isFinishing && Math.random() < 0.5) { // Added random chance (50% per frame)
             const boostParticleColor = new THREE.Color(0x80ffff); // Bright cyan
             const particleVelocity = new THREE.Vector3( // Shoot backwards slightly spread
                (Math.random() - 0.5) * 1,
                (Math.random() - 0.5) * 1,
                BASE_FORWARD_SPEED * 0.5 // Adjust speed based on base speed
             );
             const spawnPos = playerSphere.position.clone().add(new THREE.Vector3(0, 0, sphereRadius)); // Spawn behind sphere
             createParticle(spawnPos, boostParticleColor, particleVelocity, 0.3, 0.18); // Reduced life and scale
        }
        */

        // --- Ground check / Gap detection ---
        let landedThisFrame = false; // Track landing
        if (tileBelow === TileType.Standard || tileBelow === TileType.Boost || tileBelow === TileType.SlowMotion || tileBelow === TileType.Finish) {
            if (playerSphere.position.y <= sphereBaseY && !isOnGround) { // Landed this frame
                landedThisFrame = true;
            }
            if (playerSphere.position.y <= sphereBaseY) {
                playerSphere.position.y = sphereBaseY;
                velocityY = 0;
                isOnGround = true;
                isBoostJumping = false;
            }
            else {
                isOnGround = false;
            }
        } else if (tileBelow === TileType.Gap || tileBelow === null) {
             if (isOnGround) { // Just left solid ground for a gap
                  // Optional: Add particles for rolling off edge?
             }
            isOnGround = false;
            // Check for falling off
            if (playerSphere.position.y < -10 && !gameOver) {
                lives -= 1; // Decrement lives
                updateUI(); // Update UI immediately

                if (lives > 0) {
                    showMessage('Fell Off! Lost a life.');
                    retryQuitContainer!.classList.remove('hidden'); // Show buttons
                    jumpButtonContainer!.classList.add('hidden'); // Hide jump button when retry/quit shown
                    // Pause the game loop by cancelling the frame
                    cancelAnimationFrame(animationFrameId!);
                    animationFrameId = null;
                    return; // Stop this frame
                } else {
                    // Game Over - Fell Off (Final life)
                    gameOver = true;
                    showMessage('Fell Off! Game Over!');
                    retryQuitContainer!.classList.add('hidden'); // Ensure buttons are hidden
                    saveHighScore(score); // Save score on final game over
                    updateUI(); // Final UI update

                    // Show restart button immediately
                    timerElement!.style.display = 'none';
                    scoreElement!.style.display = 'none';
                    livesElement!.style.display = 'none';
                    levelNameElement!.style.display = 'none';
                    jumpButtonContainer!.classList.add('hidden');
                    restartGameContainer!.classList.remove('hidden');

                    cancelAnimationFrame(animationFrameId!);
                    animationFrameId = null;
                    return; // Stop the loop
                }
            }
        }

        // --- Emit Landing Particles ---
        if (landedThisFrame) {
             const landColor = new THREE.Color(0xaaaaaa); // Greyish
             for (let i = 0; i < 10; i++) { // Reduced count
                 const angle = Math.random() * Math.PI * 2;
                 const spread = Math.random() * 1.0; // Reduced spread
                 const velocity = new THREE.Vector3(
                     Math.cos(angle) * spread,
                     Math.random() * 0.3 + 0.1, // Less upwards burst
                     Math.sin(angle) * spread 
                 );
                 // Spawn slightly below sphere at landing point
                 createParticle(new THREE.Vector3(playerSphere.position.x, sphereBaseY - sphereRadius, playerSphere.position.z), landColor, velocity, 0.35, 0.12); // Reduced life and scale
             }
        }

        // --- Check for Finish Line Crossing (AFTER movement) ---
        if (!isFinishing && playerSphere.position.z <= trackEndZ) {
            console.log("Finish line crossed!");
            isFinishing = true; // Start the finishing sequence
            score += Math.max(0, Math.ceil(remainingTime)) * 10; // Add remaining time score NOW
            updateUI(); // Update score display immediately
            // NOTE: Level transition now happens inside the isFinishing block when speed is low enough
        }
    } // --- End of Core Game Logic (!isCountingDown) block ---

    // --- Animate Boost Tile Arrow Texture Pulse ---
    // UNCOMMENTED FOR EFFECT
    const arrowTexture = boostTopMaterial.map as THREE.CanvasTexture;
    if (arrowTexture) {
        const pulseSpeed = 3; // How fast the pulse is
        const minScale = 0.9; // Minimum scale factor
        const maxScale = 1.1; // Maximum scale factor
        const scaleRange = maxScale - minScale;
        const pulseScale = minScale + (Math.sin(elapsedTime * pulseSpeed) + 1) / 2 * scaleRange; // Oscillates minScale..maxScale
        
        arrowTexture.repeat.set(pulseScale, pulseScale);
        // Adjust offset to keep texture centered when scaling
        arrowTexture.offset.set((1 - pulseScale) / 2, (1 - pulseScale) / 2);
        arrowTexture.needsUpdate = true; // Texture properties changed
    }
    

    // --- Update Particles ---
    updateParticles(delta);

    // --- Camera Logic (Runs even during countdown) ---
    // Define the base offset from the sphere
    const baseOffset = new THREE.Vector3(0, 1.5, 3.5); 

    // Create Quaternion for yaw and pitch
    const yawQuaternion = new THREE.Quaternion().setFromAxisAngle(new THREE.Vector3(0, 1, 0), cameraYaw);
    const pitchQuaternion = new THREE.Quaternion().setFromAxisAngle(new THREE.Vector3(1, 0, 0), cameraPitch);
    const combinedQuaternion = yawQuaternion.multiply(pitchQuaternion); // Order matters: Yaw first, then Pitch

    // Rotate the base offset
    const rotatedOffset = baseOffset.clone().applyQuaternion(combinedQuaternion);

    // Calculate final camera position
    const cameraPosition = playerSphere.position.clone().add(rotatedOffset);

    // Set camera position and lookAt
    camera.position.copy(cameraPosition);
    camera.lookAt(playerSphere.position);
    
    // --- Update UI (Runs even during countdown, but logic inside might be paused) ---
    // Only update if not waiting for restart (This might need adjustment if UI should freeze too)
    if (!messageElement!.textContent?.includes('Lost a life')) {
         if (!isCountingDown) updateUI(); // Only update timer/score/lives if not counting down
    }

    // --- Render (Runs even during countdown) ---
    renderer.render(scene, camera);
}

// --- Resize Handling ---
function onWindowResize() {
    camera.aspect = window.innerWidth / window.innerHeight;
    camera.updateProjectionMatrix();
    renderer.setSize(window.innerWidth, window.innerHeight);
}

window.addEventListener('resize', onWindowResize, false);

// --- Helper Functions ---
function restartCurrentLevel() {
    console.log("Restarting current level...");
    jumpButtonContainer!.classList.add('hidden'); // Hide jump button immediately
    loadLevel(currentLevelIndex); // Reload the current level (will show button after countdown)
}

// --- Restart Game Function ---
function restartGame() {
    console.log("Restarting game from beginning...");
    score = 0;
    lives = 3; // Reset lives to initial value
    restartGameContainer!.classList.add('hidden');
    jumpButtonContainer!.classList.add('hidden'); // Hide jump button immediately
    // Make sure standard UI elements are visible again for the new game
    timerElement!.style.display = '';
    scoreElement!.style.display = '';
    livesElement!.style.display = '';
    levelNameElement!.style.display = '';
    
    loadLevel(0); // Load level 1 (will show button after countdown)
}

// --- Start ---
animate();
